import {useState, useEffect} from "react"
import filtersStub from "@/data/filtersStub.json"
import {isStubEnabled} from "@/config/stubConfig"
import {MessageFilter} from "@/features/rulesets"

// Use the stub config for filters
export const USE_FILTERS_STUB_DATA = isStubEnabled("filters")

/**
 * Hook to use stub filters data instead of real data
 * This mimics behavior of a real filters data hook
 */
export function useStubFilters() {
  const [loading, setLoading] = useState(true)
  const [filters, setFilters] = useState<MessageFilter[]>([])

  useEffect(() => {
    // Simulate API loading
    const timer = setTimeout(() => {
      setFilters(filtersStub as MessageFilter[])
      setLoading(false)
    }, 800)

    return () => clearTimeout(timer)
  }, [])

  return {
    loading,
    error: undefined,
    data: filters,
  }
}
